export default  {"src":"/_next/static/image/public/images/icon_sm_home_dark.06aec39c546945e859822e91d2d798ae.svg","height":23,"width":24};